import { FunctionComponent } from 'react';
import { Box, Chip } from '@mui/material';

// Small reusable Dutch-member indicator. Used on the stock transfer list
// (StockTransfers.tsx), the read-only party blocks on the detail page
// (StockTransferDetail.tsx), and the user detail page (UserDetail.tsx).
//
// The flag is drawn as three CSS bands (red/white/blue) instead of the 🇳🇱 emoji,
// because Windows does not compose regional-indicator emoji into flag images
// (it falls back to the literal letters "NL"). CSS renders identically on
// Windows / macOS / Linux. Render only when the party is Dutch.

const DutchFlagGraphic: FunctionComponent = () => {
  return (
    <Box sx={{
      display: 'inline-flex',
      flexDirection: 'column',
      width: 14,
      height: 10,
      borderRadius: 0.5,
      overflow: 'hidden',
      border: '0.5px solid rgba(0,0,0,0.15)',
      flexShrink: 0,
    }}>
      <Box sx={{height: '33.33%', backgroundColor: '#AE1C28'}} />
      <Box sx={{height: '33.33%', backgroundColor: '#FFFFFF'}} />
      <Box sx={{height: '33.33%', backgroundColor: '#21468B'}} />
    </Box>
  );
};

type DutchFlagProps = {
  sx?: object;
};

export const DutchFlag: FunctionComponent<DutchFlagProps> = ({sx}) => {
  return (
    <Chip
      size="small"
      icon={<DutchFlagGraphic />}
      label="NL"
      sx={{
        height: 20,
        fontSize: '0.7rem',
        paddingLeft: '2px',
        backgroundColor: 'rgba(92, 191, 141, 0.15)',
        color: 'rgb(16, 81, 86)',
        border: '1px solid rgba(92, 191, 141, 0.4)',
        '& .MuiChip-icon': {
          marginLeft: '6px',
          marginRight: '-4px',
          width: 14,
          height: 10,
        },
        ...sx
      }}
    />
  );
}
